// @unocss-include
import Layout from '@/components/layout/sider-menu-layout/index.vue';
import type { SiteRouteItem } from '@/router/types';
import { PermissionPageKey } from '@/types/permission';

const route: SiteRouteItem = {
  path: '/precision',
  component: Layout,
  name: PermissionPageKey.Precision,
  redirect: '/precision/cover-task', // 默认首页子路由
  meta: {
    title: '精准测试服务',
    icon: 'mingcute:target-fill',
    iconCls: 'bg-cyan-500',
    roles: ['admin'],
  },
  children: [
    {
      path: 'cover-task',
      name: PermissionPageKey.PrecisionCoverTask,
      meta: { title: '覆盖率任务', icon: 'ph:record-fill', keepAlive: true },
      children: [
        {
          path: '',
          name: PermissionPageKey.PrecisionCoverTaskList,
          component: () => import('../pages/cover-task/cover-task-view/index.vue'),
          meta: { title: '任务列表' },
        },
        {
          path: ':id/api-report',
          name: PermissionPageKey.PrecisionCoverTaskApiReport,
          component: () => import('../pages/cover-task/cover-task-view/sub-pages/cover-task-api-report.vue'),
          meta: { title: '接口覆盖率列表', hideInMenu: true },
        },
        {
          path: ':id/full-coverage',
          name: PermissionPageKey.PrecisionCoverTaskFull,
          component: () => import('../pages/cover-task/cover-task-view/sub-pages/cover-task-full.vue'),
          meta: { title: '全量覆盖率', hideInMenu: true },
        },
        {
          path: ':id/increment-coverage',
          name: PermissionPageKey.PrecisionCoverTaskIncrement,
          component: () => import('../pages/cover-task/cover-task-view/sub-pages/cover-task-increment.vue'),
          meta: { title: '增量覆盖率', hideInMenu: true },
        },
      ],
    },

    {
      path: 'case-recommend',
      name: PermissionPageKey.PrecisionCaseRecommend,
      component: () => import('../pages/cover-task//case-recommend/index.vue'),
      meta: { title: '用例推荐', icon: 'ph:record-fill' },
    },
    {
      path: 'server-list',
      name: PermissionPageKey.PrecisionCoverServerList,
      component: () => import('../pages/cover-task/cover-server-list/index.vue'),
      meta: { title: '注册中心', icon: 'ri:registered-line' },
    },
  ],
};

export default route;
